/* Home page, 16 Oct 2026: sticky-note scenes, the lineup one at a time, and the Trigger Wall loader. */
(function () {
  "use strict";
  var REDUCE = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  function qsa(r, s) { return [].slice.call((r || document).querySelectorAll(s)); }
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function progress(sec) {
    var span = sec.offsetHeight - innerHeight, top = sec.getBoundingClientRect().top;
    return span > 0 ? clamp(-top / span) : (top < 0 ? 1 : 0);
  }

  /* ------------------------------------------------ sticky-note scenes ([data-notefall]) */
  /* Each note has a point in the scroll (data-fall-at, 0-1 of the scene). Passing it plays the fall
     (lift, detach, drop); scrolling back above it puts the note back. */
  var scenes = [];
  function prepScene(sec) {
    if (sec._nf) return;
    var notes = qsa(sec, "[data-fall-at]").map(function (n) { return { el: n, at: +n.getAttribute("data-fall-at"), state: "on", t: [], hand: false }; });
    sec._nf = { notes: notes };
    scenes.push(sec);
    /* 17 Oct: a note can also be clicked (tapped) off; it falls the same way and stays off */
    notes.forEach(function (n) {
      n.el.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); n.hand = true; fall(n); setTimeout(req, 1400); });
    });
  }
  function clearT(n) { n.t.forEach(clearTimeout); n.t = []; }
  function fall(n) {
    if (n.state !== "on") return;
    n.state = "falling"; clearT(n);
    var e = n.el;
    e.classList.remove("is-back");
    e.classList.add("is-lift");
    n.t.push(setTimeout(function () { e.classList.remove("is-lift"); e.classList.add("is-detach"); }, 190));
    n.t.push(setTimeout(function () { e.classList.remove("is-detach"); e.classList.add("is-fall"); }, 420));
    n.t.push(setTimeout(function () { e.classList.add("is-gone"); n.state = "gone"; }, 1380));
  }
  function back(n) {
    if (n.state === "on") return;
    clearT(n); n.state = "on";
    var e = n.el;
    e.classList.remove("is-lift", "is-detach", "is-fall", "is-gone");
    void e.offsetWidth; e.classList.add("is-back");
  }
  function updScene(sec) {
    var p = progress(sec), st = sec._nf, all = true;
    st.notes.forEach(function (n) {
      if (p >= n.at) fall(n); else if (p < n.at - 0.03 && !n.hand) back(n);
      if (p < n.at && !n.hand) all = false;
    });
    sec.toggleAttribute("data-going", p > 0.02);
    if (all) { if (!sec.hasAttribute("data-done")) setTimeout(function () { if (st.notes.every(function (n) { return n.state !== "on"; })) sec.setAttribute("data-done", ""); }, 700); }
    else sec.removeAttribute("data-done");
  }

  /* ------------------------------------------------ the lineup, one at a time ([data-lineslide]) */
  /* The scroll is split per flavour: most of a flavour's share opens its box (the film is scrubbed),
     the rest slides the next flavour in from the right. Each film's frames load when it is near. */
  var lines = [];
  function prepFilm(c) {
    if (c._f) return c._f;
    var urls = (c.getAttribute("data-frames") || "").split("|").filter(Boolean);
    var f = { c: c, ctx: c.getContext("2d"), urls: urls, imgs: [], ok: [], last: -1, loading: false };
    f.load = function () {
      if (f.loading) return; f.loading = true;
      urls.forEach(function (u, i) {
        var im = new Image(); im.decoding = "async";
        im.onload = function () { f.ok[i] = true; if (i === 0 || i === f.want) draw(f, f.want || 0, true); };
        im.src = u; f.imgs[i] = im;
      });
    };
    c._f = f; return f;
  }
  function draw(f, want, force) {
    f.want = want;
    var i = -1, d;
    for (d = 0; d < f.urls.length; d++) {
      if (f.ok[want - d]) { i = want - d; break; }
      if (f.ok[want + d]) { i = want + d; break; }
    }
    if (i < 0 || (i === f.last && !force)) return;
    f.last = i;
    f.ctx.clearRect(0, 0, f.c.width, f.c.height);
    f.ctx.drawImage(f.imgs[i], 0, 0, f.c.width, f.c.height);
    f.c.parentNode.classList.add("is-ready");
  }
  function prepLine(sec) {
    if (sec._ls) return;
    var films = qsa(sec, "canvas[data-frames]").map(prepFilm);
    sec._ls = { films: films, n: films.length, slide: 0 };
    lines.push(sec);
    /* 17 Oct: arrows. Each flavour lives at a point of the scroll; an arrow scrolls the page there, so the slide
       and the box opening play exactly as if the visitor had scrolled */
    qsa(sec, "[data-ls-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        var st = sec._ls, step = +b.getAttribute("data-ls-step");
        var k = step > 0 ? Math.floor(st.slide + 0.05) + 1 : Math.ceil(st.slide - 0.05) - 1;
        k = Math.max(0, Math.min(st.n - 1, k));
        var span = sec.offsetHeight - innerHeight, top = sec.getBoundingClientRect().top + scrollY;
        var p = k === 0 ? 0 : (k + 0.02) / st.n;
        scrollTo({ top: top + p * span + 2, behavior: REDUCE ? "auto" : "smooth" });
      });
    });
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { if (films[0]) films[0].load(); if (films[1]) films[1].load(); io.disconnect(); } }, { rootMargin: "150% 0px" });
      io.observe(sec);
    } else films.forEach(function (f) { f.load(); });
  }
  function ease(t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function updLine(sec) {
    var st = sec._ls, n = st.n; if (!n) return;
    var p = progress(sec) * n;                       // 0 .. n
    var i = Math.min(n - 1, Math.floor(p)), t = p - i; // flavour i, t through its share
    var OPEN = .68;                                   // this much of a share opens the box; the rest slides on
    var open = clamp(t / OPEN), slide = i;
    if (i < n - 1 && t > OPEN) slide = i + ease(clamp((t - OPEN) / (1 - OPEN)));
    if (p >= n) { i = n - 1; open = 1; slide = n - 1; }
    sec.style.setProperty("--slide", slide.toFixed(4));
    st.slide = slide;
    sec.toggleAttribute("data-first", slide < 0.5);
    sec.toggleAttribute("data-last", slide > n - 1.5);
    st.films.forEach(function (f, k) {
      var o = k < i ? 1 : k > i ? 0 : open;
      if (k === i + 1 && t > OPEN) o = 0;
      var want = Math.round(o * (f.urls.length - 1));
      if (Math.abs(k - i) <= 1) { f.load(); draw(f, want); }
    });
    sec.toggleAttribute("data-going", p > 0.05);
    /* 19 Oct: the first-order note waits until the visitor has seen all four flavours (last box open) */
    if (!st.seen && i === n - 1 && open > 0.9) { st.seen = true; document.dispatchEvent(new CustomEvent("tg:lineup-seen")); }
  }

  /* ------------------------------------------------ the engine */
  var raf = 0;
  function tick() {
    raf = 0;
    scenes.forEach(updScene);
    lines.forEach(updLine);
  }
  function req() { if (!raf) raf = requestAnimationFrame(tick); }
  function init(root) {
    qsa(root, "[data-pdp-gallery]").forEach(wireGallery);
    qsa(root, "[data-fit-width]").forEach(fitWidth);
    qsa(root, "[data-zoom-src]").forEach(wireZoom);
    /* cart page checkout -> Shiprocket's BUY NOW (it only lives in the bag drawer) */
    qsa(root, "[data-sr-proxy]").forEach(function (a) {
      if (a._sr) return; a._sr = true;
      a.addEventListener("click", function (e) {
        var sr = document.querySelector(".sr-headless-checkout");
        e.preventDefault();
        if (sr) sr.click(); else location.href = "/checkout";   // Shiprocket not loaded: Shopify checkout
      });
    });
    if (REDUCE) return;
    qsa(root, "[data-notefall]").forEach(prepScene);
    qsa(root, "[data-lineslide]").forEach(prepLine);
    tick();
  }
  addEventListener("scroll", req, { passive: true });
  addEventListener("resize", req);
  document.addEventListener("shopify:section:load", function (e) { scenes = scenes.filter(function (s) { return s.isConnected; }); lines = lines.filter(function (s) { return s.isConnected; }); init(e.target); });

  /* ------------------------------------------------ the product gallery ([data-pdp-gallery]) */
  /* One photo at a time: arrows, keyboard and swipe. Slide 1 is the box: tapping it plays the sleeve lifting off
     (the frames load on the first tap) and tapping again plays it back. */
  function wireGallery(g) {
    if (g._g) return; g._g = true;
    var slides = qsa(g, "[data-gal-slide]"), i = 0, n = slides.length;
    var nEl = g.querySelector("[data-gal-n]"), tEl = g.querySelector("[data-gal-total]");
    if (tEl) tEl.textContent = n;
    function show(k) {
      i = (k + n) % n;
      slides.forEach(function (s, x) { s.classList.toggle("is-on", x === i); });
      if (nEl) nEl.textContent = i + 1;
    }
    qsa(g, "[data-gal-step]").forEach(function (b) { b.addEventListener("click", function () { show(i + (+b.getAttribute("data-gal-step"))); }); });
    g.addEventListener("keydown", function (e) { if (e.key === "ArrowLeft") show(i - 1); if (e.key === "ArrowRight") show(i + 1); });
    var x0 = null;
    g.addEventListener("pointerdown", function (e) { x0 = e.clientX; });
    g.addEventListener("pointerup", function (e) { if (x0 === null) return; var d = e.clientX - x0; x0 = null; if (Math.abs(d) > 40) { g._swiped = true; show(i + (d < 0 ? 1 : -1)); setTimeout(function () { g._swiped = false; }, 50); } });

    var open = g.querySelector("[data-gal-open]");
    if (!open) return;
    var c = open.querySelector("canvas"), tag = open.querySelector("[data-gal-tag]");
    var f = prepFilm(c), at = 0, target = 0, anim = 0;
    function frame() {
      anim = 0;
      var step = (target > at ? 1 : -1) * Math.max(.6, f.urls.length / 40);
      at = Math.abs(target - at) <= Math.abs(step) ? target : at + step;
      draw(f, Math.round(at));
      if (at !== target) anim = requestAnimationFrame(frame);
    }
    open.addEventListener("click", function () {
      if (g._swiped) return;
      var isOpen = open.getAttribute("aria-pressed") === "true";
      open.setAttribute("aria-pressed", String(!isOpen));
      open.setAttribute("aria-label", isOpen ? "Open the box" : "Close the box");
      if (tag) tag.innerHTML = isOpen ? tag.getAttribute("data-open-label") : tag.getAttribute("data-close-label");
      f.load();
      target = isOpen ? 0 : f.urls.length - 1;
      if (REDUCE) { at = target; draw(f, at, true); return; }
      if (!anim) anim = requestAnimationFrame(frame);
    });
    /* start loading the frames once the photo is near, so the first tap is instant */
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { f.load(); io.disconnect(); } }, { rootMargin: "50% 0px" });
      io.observe(g);
    }
  }



  /* ------------------------------ a gallery picture opened large ([data-zoom-src] -> [data-zoom]); tap to zoom in */
  function wireZoom(btn) {
    if (btn._z) return; btn._z = true;
    var g = btn.closest("[data-pdp-gallery]"), box = btn.closest(".tg-buy__gallery").querySelector("[data-zoom]") || document.querySelector("body > [data-zoom]");
    if (!box) return;
    /* lifted to <body> so no section's stacking (sticky header, sticky buy bar) can sit on top of it */
    if (box.parentNode !== document.body) document.body.appendChild(box);
    var stage = box.querySelector("[data-zoom-stage]"), img = box.querySelector("[data-zoom-img]"), last = null;
    function close() {
      box.hidden = true; img.classList.remove("is-zoomed"); img.style.width = "";
      document.documentElement.classList.remove("tg-zoom-on");
      if (last) last.focus({ preventScroll: true });
    }
    btn.addEventListener("click", function () {
      if (g && g._swiped) return;
      last = btn;
      img.src = btn.getAttribute("data-zoom-src"); img.alt = btn.getAttribute("data-zoom-alt") || "";
      box.hidden = false; document.documentElement.classList.add("tg-zoom-on");
      box.querySelector("[data-zoom-close]").focus({ preventScroll: true });
    });
    img.addEventListener("click", function (e) {
      e.stopPropagation();
      var r = img.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
      if (img.classList.toggle("is-zoomed")) {
        img.style.width = Math.max(img.naturalWidth || 1100, stage.clientWidth * 1.6) + "px";
        stage.scrollLeft = fx * img.offsetWidth - stage.clientWidth / 2;
        stage.scrollTop = fy * img.offsetHeight - stage.clientHeight / 2;
      } else img.style.width = "";
    });
    stage.addEventListener("click", function (e) { if (e.target === stage) close(); });
    box.querySelector("[data-zoom-close]").addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !box.hidden) close(); });
  }

  /* -------------------------------------------- text that fills its width exactly ([data-fit-width]) */
  function fitWidth(el) {
    var inner = el.firstElementChild; if (!inner) return;
    function fit() {
      el.style.fontSize = "100px";
      var w = inner.getBoundingClientRect().width, avail = el.clientWidth;
      if (w > 0 && avail > 0) el.style.fontSize = (100 * avail / w * 0.995).toFixed(2) + "px";
    }
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    var t; window.addEventListener("resize", function () { clearTimeout(t); t = setTimeout(fit, 120); });
  }

  /* ------------------------------------------------ the Trigger Wall loader */
  function wireLoader() {
    var L = document.querySelector("[data-tg-loader]");
    var html = document.documentElement;
    if (!L || !html.classList.contains("tg-loader-on")) { if (L) L.remove(); return; }
    var bullets = [].slice.call(L.querySelectorAll("[data-loader-meter] i")), pct = L.querySelector("[data-loader-pct]");
    /* progress: the real page load (images and all) drives it, but it never runs faster than MIN or slower than MAX */
    var MIN = 2400, MAX = 6000, t0 = performance.now(), loaded = document.readyState === "complete", shown = 0, done = false;
    if (!loaded) addEventListener("load", function () { loaded = true; });
    function show(p) {
      shown = p;
      bullets.forEach(function (b, i) { b.style.setProperty("--f", Math.max(0, Math.min(1, p * 4 - i)).toFixed(3)); });
      if (pct) pct.textContent = Math.round(p * 100) + "%";
    }
    function lift() {
      if (done) return; done = true; show(1);
      try { sessionStorage.setItem("tgLoaderSeen", "1"); } catch (e) {}
      setTimeout(function () {
        L.classList.add("is-up");
        setTimeout(function () { html.classList.remove("tg-loader-on"); L.remove(); }, 950);
      }, 320);
    }
    function tick(now) {
      if (done) return;
      var t = (now - t0) / MIN;                                    /* time-based share */
      var cap = loaded ? 1 : Math.min(.9, (now - t0) / MAX);         /* without the load event it stops at 90% */
      var p = Math.min(cap, t < 1 ? t : 1);
      if (!loaded && (now - t0) > MAX) p = 1;
      show(Math.max(shown, p));
      if (shown >= 1) lift(); else requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
    var sk = L.querySelector("[data-loader-skip]");
    if (sk) sk.addEventListener("click", function (e) { e.stopPropagation(); lift(); });
    addEventListener("keydown", function (e) { if (e.key === "Escape") lift(); });
    L.addEventListener("click", lift);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(document); wireLoader(); });
  else { init(document); wireLoader(); }
})();
